export const MOBILE_SDK_DASHBOARD_PAGE_MAIN_TITLE_ID = 'mobile-sdk-dashboard-page-main-title';
export const MOBILE_SDK_DASHBOARD_PAGE_OLDER_TESTS_LINK_ID =
	'mobile-sdk-dashboard-page-older-tests-link';
export const MOBILE_SDK_DASHBOARD_PAGE_FILTERS_SECTION_ID =
	'mobile-sdk-dashboard-page-filters-section';
export const MOBILE_SDK_DASHBOARD_PAGE_TABLE_SECTION_ID = 'mobile-sdk-dashboard-page-table-section';
export const MOBILE_SDK_DASHBOARD_PAGE_SUMMARY_TITLE_ID = 'mobile-sdk-dashboard-page-usage-title';
export const MOBILE_SDK_DASHBOARD_PAGE_SUMMARY_SECTION_ID =
	'mobile-sdk-dashboard-page-usage-section';
export const MOBILE_SDK_SHOW_ONLY_LATEST_TESTS_TOGGLE_ID =
	'mobile-sdk-show-only-latest-tests-toggle';

// Single Test Page
export const MOBILE_SDK_TEST_HEADER_DAID = 'mobile-sdk-test-header';
export const MOBILE_SDK_TEST_TITLE_DAID = 'mobile-sdk-test-title';
export const MOBILE_SDK_TEST_COPY_URL_BUTTON_DAID = 'mobile-sdk-test-copy-url-button';
export const MOBILE_SDK_TEST_ALL_ISSUES_TAB_DAID = 'mobile-sdk-test-all-issues-tab';
export const MOBILE_SDK_TEST_ISSUES_TABLE_DAID = 'mobile-sdk-test-issues-table';
export const MOBILE_SDK_TEST_FILTERS_SECTION_ID = 'mobile-sdk-test-filters-section';
export const MOBILE_SDK_TEST_OVERVIEW_TAB_DAID = 'mobile-sdk-test-overview-tab';
export const MOBILE_SDK_TEST_OVERVIEW_SUMMARY_DAID = 'mobile-sdk-test-overview-summary';
export const MOBILE_SDK_TEST_BREAKDOWN_BY_SEVERITY_PIE_CHART_DAID =
	'mobile-sdk-test-breakdown-by-severity-pie-chart';
export const MOBILE_SDK_TEST_SCAN_SEVERITIES_GRAPH_DAID = 'mobile-sdk-test-scan-severities-graph';
export const MOBILE_SDK_TEST_TOP_ISSUE_TYPES_GRAPH_DAID = 'mobile-sdk-test-top-issue-types-graph';
export const MOBILE_SDK_TOTAL_ISSUES_BREAKDOWN_BY_ISSUE_TYPE_CHART_DAID =
	'mobile-sdk-total-issues-breakdown-by-issue-type-chart';
